import React from 'react';
import styled from 'styled-components';
import { Inline } from '@99designs/emu';
import { minHeights } from '@99designs/emu/settings';

interface CheckboxProps extends React.InputHTMLAttributes<HTMLInputElement> {
    children: React.ReactNode;
}

const CheckboxInput = styled.input`
    && {
        width: ${minHeights.inputControl}px;
        height: ${minHeights.inputControl}px;
    }
`;

const Checkbox = React.forwardRef(function Checkbox(
    { id, name, children, ...rest }: CheckboxProps,
    ref: React.RefObject<HTMLInputElement>
) {
    return (
        <Inline space="1bu">
            <CheckboxInput ref={ref} id={id} name={name} type="checkbox" {...rest} />
            <label htmlFor={id}>{children}</label>
        </Inline>
    );
});

export default Checkbox;
